import { GET_ALL_QUEUES, GET_SPECIFIC_QUEUE, GET_ALL_AUDIOS, GET_ALL_WAIT_MUSIC, GET_QUEUE_USE } from './mutation-types'
import filaHttpService from '../_services/filaHttpService'

export default {
  listarFilas: async ({ commit }) => {
    try {
      const response = await filaHttpService.getFilas()
      commit(GET_ALL_QUEUES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarFilaEspecifica: async ({ commit }, id) => {
    try {
      const response = await filaHttpService.getFila(id)
      commit(GET_SPECIFIC_QUEUE, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarFilaUse: async({ commit }, id) => {
    try {
      const response = await filaHttpService.getFilaUse(id)
      commit(GET_QUEUE_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarAudios: async ({ commit }) => {
    try {
      const response = await filaHttpService.getAudios()
      commit(GET_ALL_AUDIOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarMusicasEmEspera: async ({ commit }) => {
    try {
      const response = await filaHttpService.getMusicasEmEspera()
      commit(GET_ALL_WAIT_MUSIC, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
